var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1495 6.15487L10.6253 5.74426L8.8586 1.39373C8.54079 0.601831 7.45648 0.601831 7.13866 1.39373L5.37198 5.75403L0.857128 6.15487C0.0345461 6.22331 -0.301965 7.29872 0.324319 7.86575L3.75486 10.9747L2.72663 15.5892C2.53968 16.4299 3.409 17.0947 4.11941 16.645L7.99863 14.2009L11.8779 16.6548C12.5883 17.1045 13.4576 16.4397 13.2706 15.5989L12.2424 10.9747L15.6729 7.86575C16.2992 7.29872 15.9721 6.22331 15.1495 6.15487ZM7.99863 12.3727V3.28059L9.59706 7.23028L13.6913 7.60179L10.5879 10.4174L11.5226 14.6017L7.99863 12.3727Z",
    fill: "#FFB547"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.52a9cd85c47f1725d4747f20d4c66075.svg";
export { ForwardRef as ReactComponent };